import { Cell as RechartsCell } from 'recharts';

export const Cell = (
    props: React.ComponentProps<typeof RechartsCell>
) => {
    return <RechartsCell data-testid={'Cell-container'} {...props} />;
};

export default Cell;
